import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon, Modal } from 'semantic-ui-react';

const ConfirmationModal = props => (
  <Modal
    open onClose={props.onCancel}
    closeOnEscape
    size={props.size}
  >
    { props.headerText && <Modal.Header>{props.headerText}</Modal.Header> }
    { props.bodyText && <Modal.Content>
      {props.bodyText}
      <div className="align-right">
        <Button onClick={props.onCancel} color="grey">Nope</Button>
        <Button onClick={props.onConfirm} color="pink">Do it!</Button>
      </div>
    </Modal.Content>}

  </Modal>
);

ConfirmationModal.defaultProps = {
  size: 'tiny',
  headerText: null,
  bodyText: null,
};

ConfirmationModal.propTypes = {
  size: PropTypes.string,
  headerText: PropTypes.string,
  bodyText: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ConfirmationModal;



/** WEBPACK FOOTER **
 ** ./src/components/confirmation-modal/index.js
 **/